
// src/actions/diaries.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'
import moment from 'moment'
import { isSmartPhone } from '../helpers/agent-type'

export const FETCH_DIARIES = "FETCH_DIARIES"
export const FETCH_DIARIES_REQUESTED = "FETCH_DIARIES_REQUESTED"
export const FETCH_DIARIES_COMPLETED = "FETCH_DIARIES_COMPLETED"
export const FETCH_DIARIES_FAILED = "FETCH_DIARIES_FAILED"

export function fetchDiariesRequested(group_id) {
  return {
    type: FETCH_DIARIES_REQUESTED,
    group_id,
  }
}

export function fetchDiaries(group_id, offset) {
  return function(dispatch) {
    dispatch(fetchDiariesRequested(group_id))
    return api.get(`/diaries`, { group_id, offset })
        .then((results)=> {
          dispatch(fetchDiariesCompleted(results, offset, group_id))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchDiariesFailed(error, group_id)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchDiariesCompleted(results, offset, group_id) {
  return {
    type: FETCH_DIARIES_COMPLETED,
    results, offset, group_id,
  }
}

export function fetchDiariesFailed(error, group_id) {
  return {
    type: FETCH_DIARIES_FAILED,
    error, group_id,
  }
}

export const FLUSH_UNREAD_DIARIES = "FLUSH_UNREAD_DIARIES"
export const FLUSH_UNREAD_DIARIES_REQUESTED = "FLUSH_UNREAD_DIARIES_REQUESTED"
export const FLUSH_UNREAD_DIARIES_COMPLETED = "FLUSH_UNREAD_DIARIES_COMPLETED"
export const FLUSH_UNREAD_DIARIES_FAILED = "FLUSH_UNREAD_DIARIES_FAILED"

export function flushUnreadDiariesRequested() {
  return {
    type: FLUSH_UNREAD_DIARIES_REQUESTED
  }
}

export function flushUnreadDiaries(group_id) {
  return function(dispatch) {
    dispatch(flushUnreadDiariesRequested())
    return api.get(`/diaries/flush`, { group_id })
        .then((results)=> {
          dispatch(flushUnreadDiariesCompleted(results, group_id))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(flushUnreadDiariesFailed(error, group_id)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function flushUnreadDiariesCompleted(results, group_id) {
  return {
    type: FLUSH_UNREAD_DIARIES_COMPLETED,
    results, group_id
  }
}

export function flushUnreadDiariesFailed(error, group_id) {
  return {
    type: FLUSH_UNREAD_DIARIES_FAILED,
    error, group_id
  }
}

export const POST_OR_UPDATE_DIARY = "POST_OR_UPDATE_DIARY"
export const POST_OR_UPDATE_DIARY_REQUESTED = "POST_OR_UPDATE_DIARY_REQUESTED"
export const POST_OR_UPDATE_DIARY_COMPLETED = "POST_OR_UPDATE_DIARY_COMPLETED"
export const POST_OR_UPDATE_DIARY_FAILED = "POST_OR_UPDATE_DIARY_FAILED"

export function postOrUpdateDiaryRequested(group_id) {
  return {
    type: POST_OR_UPDATE_DIARY_REQUESTED,
    group_id,
  }
}

export function postOrUpdateDiary(group_id, diary_id, category, reported_at, subject, content, upload_files, upload_videos, attach_json, mentions) {
  return function(dispatch) {
    dispatch(postOrUpdateDiaryRequested(group_id))
    return (diary_id && api.put(`/diaries/${diary_id}`, {
          saved: false, category, reported_at: moment(reported_at).format('YYYY-MM-DD'), subject, content, upload_files, upload_videos, attach_json, mentions,
        }) || api.post(`/diaries`, {
          group_id, category, saved: false, reported_at: moment(reported_at).format('YYYY-MM-DD'), subject, content, upload_files, upload_videos, attach_json, mentions,
        }))
        .then((results)=> {
          dispatch(postOrUpdateDiaryCompleted(results, group_id))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(postOrUpdateDiaryFailed(error, group_id)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function postOrUpdateDiaryCompleted(results, group_id) {
  return {
    type: POST_OR_UPDATE_DIARY_COMPLETED,
    results, group_id,
  }
}

export function postOrUpdateDiaryFailed(error, group_id) {
  return {
    type: POST_OR_UPDATE_DIARY_FAILED,
    error, group_id,
  }
}

export const DELETE_DIARY = "DELETE_DIARY"
export const DELETE_DIARY_REQUESTED = "DELETE_DIARY_REQUESTED"
export const DELETE_DIARY_COMPLETED = "DELETE_DIARY_COMPLETED"
export const DELETE_DIARY_FAILED = "DELETE_DIARY_FAILED"

export function deleteDiaryRequested() {
  return {
    type: DELETE_DIARY_REQUESTED
  }
}

export function deleteDiary(diary_id) {
  return function(dispatch) {
    dispatch(deleteDiaryRequested())
    return api.delete(`/diaries/${diary_id}`)
        .then((results)=> {
          dispatch(deleteDiaryCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(deleteDiaryFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function deleteDiaryCompleted(results) {
  return {
    type: DELETE_DIARY_COMPLETED,
    results,
  }
}

export function deleteDiaryFailed(error) {
  return {
    type: DELETE_DIARY_FAILED,
    error,
  }
}

export const MARK_DIARY_READ = "MARK_DIARY_READ"
export const MARK_DIARY_READ_REQUESTED = "MARK_DIARY_READ_REQUESTED"
export const MARK_DIARY_READ_COMPLETED = "MARK_DIARY_READ_COMPLETED"
export const MARK_DIARY_READ_FAILED = "MARK_DIARY_READ_FAILED"

export function markDiaryReadRequested() {
  return {
    type: MARK_DIARY_READ_REQUESTED
  }
}

export function markDiaryRead(diary_id) {
  return function(dispatch) {
    dispatch(markDiaryReadRequested())
    return api.post(`/readers/${diary_id}`)
        .then((results)=> {
          dispatch(markDiaryReadCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(markDiaryReadFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function markDiaryReadCompleted(results) {
  return {
    type: MARK_DIARY_READ_COMPLETED,
    results,
  }
}

export function markDiaryReadFailed(error) {
  return {
    type: MARK_DIARY_READ_FAILED,
    error,
  }
}

export const CLEAR_DIARIES = "CLEAR_DIARIES"

export function clearDiaries(group_id = undefined) {
  return {
    type: CLEAR_DIARIES,
    group_id
  }
}

export const LOAD_DIARY = "LOAD_DIARY"

export function loadDiary(diary, opt = {}) {
  return {
    type: LOAD_DIARY,
    diary,
    appending: opt.appending,
    own_post: opt.own_post,
    deleted: opt.deleted,
    group_id: opt.group_id,
  }
}

export const MERGE_NEW_DIARIES = "MERGE_NEW_DIARIES"

export function mergeNewDiaries(group_id) {
  return {
    type: MERGE_NEW_DIARIES,
    group_id,
  }
}



// WEBPACK FOOTER //
// ./src/actions/diaries.js